import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["__typename"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { useUnsavedChangesWarning } from '@infl-ts/util-use-unsaved-changes';
import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { constVoid, flow, pipe } from 'fp-ts/function';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AsyncButton, SaveStates } from '../../async-button';
import { saveFailure, saveSuccess, unsubscribeAllFailure, unsubscribeAllSuccess } from './alerts';
import ChallengeDigestSettings from './challenge-digest-settings';
import { EmailNotificationHeader } from './email-notification-header';
import { useEditNotificationPreferencesMutation } from './mutations';
import { NotificationSettingsBox } from './notification-settings-box';
import { PushNotificationHeader } from './push-notification-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AsyncButtonWrapper = function AsyncButtonWrapper(_ref) {
  var mutationState = _ref.mutationState,
      handleSavePreferences = _ref.handleSavePreferences,
      isDirty = _ref.isDirty;
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationvalue = useMutationMapper(mutationState, function (_ref2) {
    var editNotificationPreferences = _ref2.editNotificationPreferences;
    return editNotificationPreferences.__typename === 'EditNotificationPreferencesErrors' ? E.left(editNotificationPreferences) : E.right(editNotificationPreferences);
  }, [Saving, isDirty ? Default : Success, Error, Default]);
  return /*#__PURE__*/_jsx(AsyncButton, {
    text: ['Saving...', 'Saved', 'Save', 'Save'],
    status: mutationvalue,
    onClick: handleSavePreferences,
    "data-element": "AsyncButton",
    "data-component": "AsyncButtonWrapper",
    "data-source-file": "notification-settings.tsx"
  });
};

export var PureNotificationSettings = function PureNotificationSettings(_ref3) {
  var preferences = _ref3.preferences,
      setPreferences = _ref3.setPreferences,
      unsubscribedFromAllChanged = _ref3.unsubscribedFromAllChanged,
      setUnsubscribedFromAllChanged = _ref3.setUnsubscribedFromAllChanged,
      handleSavePreferences = _ref3.handleSavePreferences,
      mutationState = _ref3.mutationState,
      communityConfiguration = _ref3.communityConfiguration,
      setDirty = _ref3.setDirty,
      isDirty = _ref3.isDirty;
  var unsubscribedFromAllEmails = preferences.unsubscribedFromAllEmails,
      unsubscribedFromAllPushes = preferences.unsubscribedFromAllPushes;
  var unsubscribedFromAll = unsubscribedFromAllEmails && unsubscribedFromAllPushes;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var BuildFormCheckbox = function BuildFormCheckbox(_ref4) {
    var name = _ref4.name,
        label = _ref4.label,
        unsubscribed = _ref4.unsubscribed,
        preferencesOnChecked = _ref4.preferencesOnChecked;
    return /*#__PURE__*/_jsx(FormControlLabel, {
      control: /*#__PURE__*/_jsx(Checkbox, {
        name: name,
        checked: !unsubscribed && preferences[name],
        disabled: unsubscribedFromAll,
        onChange: function onChange(e) {
          setDirty();
          setPreferences(_objectSpread(_objectSpread(_objectSpread({}, preferences), e.target.checked ? preferencesOnChecked : {}), {}, _defineProperty({}, e.target.name, e.target.checked)));
        }
      }),
      label: label,
      "data-element": "FormControlLabel",
      "data-component": "BuildFormCheckbox",
      "data-source-file": "notification-settings.tsx"
    });
  };

  return /*#__PURE__*/_jsxs(NotificationSettingsBox, {
    "data-element": "NotificationSettingsBox",
    "data-component": "PureNotificationSettings",
    "data-source-file": "notification-settings.tsx",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        position: 'absolute',
        top: function top(theme) {
          return theme.spacing(2);
        },
        right: 0
      },
      "data-element": "Box",
      "data-component": "PureNotificationSettings",
      "data-source-file": "notification-settings.tsx",
      children: /*#__PURE__*/_jsx(AsyncButtonWrapper, {
        isDirty: isDirty,
        mutationState: mutationState,
        handleSavePreferences: handleSavePreferences,
        "data-element": "AsyncButtonWrapper",
        "data-component": "PureNotificationSettings",
        "data-source-file": "notification-settings.tsx"
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row'
      },
      "data-element": "Box",
      "data-source-file": "notification-settings.tsx",
      children: [/*#__PURE__*/_jsx(Switch, {
        checked: !unsubscribedFromAll,
        onChange: function onChange(e) {
          setDirty();
          setPreferences(_objectSpread(_objectSpread({}, preferences), {}, {
            unsubscribedFromAllEmails: !e.target.checked,
            unsubscribedFromAllPushes: !e.target.checked
          }));
          setUnsubscribedFromAllChanged(true);
        },
        name: "unsubscribedFromAllEmails",
        "data-element": "Switch",
        "data-source-file": "notification-settings.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          flex: 1,
          mt: 0.5,
          ml: 1
        },
        "data-element": "Box",
        "data-source-file": "notification-settings.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          "data-element": "Typography",
          "data-source-file": "notification-settings.tsx",
          children: t("Notifications turned ".concat(unsubscribedFromAll ? 'off' : 'on'))
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          "data-element": "Typography",
          "data-source-file": "notification-settings.tsx",
          children: unsubscribedFromAll ? t("You ".concat(unsubscribedFromAllChanged ? 'will be' : 'are', " unsubscribed from all notifications")) : t('Notifications will be sent to you based on your preferences below')
        })]
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      sx: {
        my: 3
      },
      "data-element": "Divider",
      "data-source-file": "notification-settings.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        my: 1
      },
      "data-element": "Box",
      "data-source-file": "notification-settings.tsx",
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'row'
        },
        "data-element": "Box",
        "data-source-file": "notification-settings.tsx",
        children: /*#__PURE__*/_jsx(EmailNotificationHeader, {
          "data-element": "EmailNotificationHeader",
          "data-source-file": "notification-settings.tsx"
        })
      }), /*#__PURE__*/_jsxs(FormGroup, {
        "data-element": "FormGroup",
        "data-source-file": "notification-settings.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          "data-element": "Typography",
          "data-source-file": "notification-settings.tsx",
          children: t('General')
        }), /*#__PURE__*/_jsx(ChallengeDigestSettings, {
          digestDeliveryOptions: communityConfiguration.digestDeliveryOptions,
          preferences: preferences,
          setPreferences: setPreferences,
          disabled: unsubscribedFromAll,
          setDirty: setDirty,
          unsubscribed: unsubscribedFromAllEmails,
          "data-element": "ChallengeDigestSettings",
          "data-source-file": "notification-settings.tsx"
        }), pipe([{
          name: 'challengeReminder',
          label: t('Challenge reminder')
        }, {
          name: 'challengeRequests',
          label: t('Challenge requests')
        }, {
          name: 'newMessages',
          label: t('New messages')
        }, {
          name: 'prospectAccepted',
          label: t('Prospect accepted')
        }, {
          name: 'challengeFeedback',
          label: t('Challenge feedback')
        }], A.map(function (notification) {
          return /*#__PURE__*/_jsx(BuildFormCheckbox, _objectSpread({
            unsubscribed: unsubscribedFromAllEmails,
            preferencesOnChecked: {
              unsubscribedFromAllEmails: false
            }
          }, notification), notification.name);
        }))]
      }), /*#__PURE__*/_jsxs(FormGroup, {
        "data-element": "FormGroup",
        "data-source-file": "notification-settings.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          sx: {
            mb: 1,
            mt: 2
          },
          "data-element": "Typography",
          "data-source-file": "notification-settings.tsx",
          children: t('Challenge and discussion activity')
        }), pipe([{
          name: 'discussionReplies',
          label: t('Replies to discussions I’m following')
        }, {
          name: 'discussionComments',
          label: t('Comments to my discussion replies')
        }, {
          name: 'challengeResponseComments',
          label: t('Comments to my challenge response')
        }, {
          name: 'discussionMentions',
          label: t('Mentions in comments or replies')
        }], A.map(function (notification) {
          return /*#__PURE__*/_jsx(BuildFormCheckbox, _objectSpread({
            unsubscribed: unsubscribedFromAllEmails,
            preferencesOnChecked: {
              unsubscribedFromAllEmails: false
            }
          }, notification), notification.name);
        }))]
      }), /*#__PURE__*/_jsxs(FormGroup, {
        "data-element": "FormGroup",
        "data-source-file": "notification-settings.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          sx: {
            mb: 1,
            mt: 2
          },
          "data-element": "Typography",
          "data-source-file": "notification-settings.tsx",
          children: t('Rewards and points')
        }), pipe([{
          name: 'badgeEarned',
          label: t('Badge earned')
        }, {
          name: 'rewardFulfilled',
          label: t('Reward fulfilled')
        }, {
          name: 'perksAvailable',
          label: t('Perks available')
        }], A.map(function (notification) {
          return /*#__PURE__*/_jsx(BuildFormCheckbox, _objectSpread({
            unsubscribed: unsubscribedFromAllEmails,
            preferencesOnChecked: {
              unsubscribedFromAllEmails: false
            }
          }, notification), notification.name);
        }))]
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      sx: {
        my: 3
      },
      "data-element": "Divider",
      "data-source-file": "notification-settings.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      "data-element": "Box",
      "data-source-file": "notification-settings.tsx",
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'row'
        },
        "data-element": "Box",
        "data-source-file": "notification-settings.tsx",
        children: /*#__PURE__*/_jsx(PushNotificationHeader, {
          "data-element": "PushNotificationHeader",
          "data-source-file": "notification-settings.tsx"
        })
      }), /*#__PURE__*/_jsx(FormGroup, {
        "data-element": "FormGroup",
        "data-source-file": "notification-settings.tsx",
        children: pipe([{
          name: 'challengesPush',
          label: t('Challenges')
        }, {
          name: 'referralsPush',
          label: t('Referrals')
        }, {
          name: 'rewardsPush',
          label: t('Rewards')
        }, {
          name: 'badgesPush',
          label: t('Badges / achievements')
        }, {
          name: 'discussionsPush',
          label: t('Discussions (Replies, Likes, Comments)')
        }], A.map(function (notification) {
          return /*#__PURE__*/_jsx(BuildFormCheckbox, _objectSpread({
            unsubscribed: unsubscribedFromAllPushes,
            preferencesOnChecked: {
              unsubscribedFromAllPushes: false
            }
          }, notification), notification.name);
        }))
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        my: 1,
        width: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
      },
      "data-element": "Box",
      "data-source-file": "notification-settings.tsx",
      children: /*#__PURE__*/_jsx(AsyncButtonWrapper, {
        isDirty: isDirty,
        mutationState: mutationState,
        handleSavePreferences: handleSavePreferences,
        "data-element": "AsyncButtonWrapper",
        "data-source-file": "notification-settings.tsx"
      })
    })]
  });
};

var useProps = function useProps(_ref5) {
  var profileId = _ref5.profileId,
      communityConfiguration = _ref5.communityConfiguration,
      _ref5$preferences = _ref5.preferences,
      __typename = _ref5$preferences.__typename,
      rest = _objectWithoutProperties(_ref5$preferences, _excluded);

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useState = useState(rest),
      preferences = _useState[0],
      _setPreferences = _useState[1];

  var _useState2 = useState(false),
      unsubscribedFromAllChanged = _useState2[0],
      setUnsubscribedFromAllChanged = _useState2[1];

  var _useUnsavedChangesWar = useUnsavedChangesWarning(false),
      setDirtyState = _useUnsavedChangesWar.setDirtyState,
      isDirty = _useUnsavedChangesWar.isDirty;

  var unsubscribedFromAllEmails = preferences.unsubscribedFromAllEmails,
      unsubscribedFromAllPushes = preferences.unsubscribedFromAllPushes;
  var unsubscribedFromAll = unsubscribedFromAllEmails && unsubscribedFromAllPushes;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var handleFailure = function handleFailure() {
    return unsubscribedFromAll ? unsubscribeAllFailure(handleSavePreferences, t) : saveFailure(handleSavePreferences, t);
  };

  var _useEditNotificationP = useEditNotificationPreferencesMutation({
    onCompleted: E.match(function () {
      return showAlert(handleFailure());
    }, function (_ref6) {
      var editNotificationPreferences = _ref6.editNotificationPreferences;

      if (editNotificationPreferences.__typename === 'EditNotificationPreferencesResult') {
        showAlert(unsubscribedFromAll ? unsubscribeAllSuccess(t) : saveSuccess(t));
        setDirtyState(false);
        setUnsubscribedFromAllChanged(false);
      } else {
        showAlert(handleFailure());
      }
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(constVoid, function (_ref7) {
        var editNotificationPreferences = _ref7.editNotificationPreferences;
        return editNotificationPreferences.__typename === 'EditNotificationPreferencesResult' && cache.modify({
          id: cache.identify(makeReference("Profile:".concat(profileId))),
          fields: {
            notificationPreferences: function notificationPreferences() {
              return editNotificationPreferences.notificationPreferences;
            }
          }
        });
      }));
    }
  }),
      _useEditNotificationP2 = _slicedToArray(_useEditNotificationP, 2),
      editNotificationPreferences = _useEditNotificationP2[0],
      mutationState = _useEditNotificationP2[1];

  var handleSavePreferences = function handleSavePreferences() {
    return editNotificationPreferences({
      variables: {
        input: preferences
      }
    });
  };

  return {
    preferences: preferences,
    setPreferences: function setPreferences(props) {
      _setPreferences(props);
    },
    unsubscribedFromAllChanged: unsubscribedFromAllChanged,
    setUnsubscribedFromAllChanged: setUnsubscribedFromAllChanged,
    handleSavePreferences: handleSavePreferences,
    mutationState: mutationState,
    communityConfiguration: communityConfiguration,
    setDirty: function setDirty() {
      return setDirtyState(true);
    },
    isDirty: isDirty
  };
};

export default Object.assign(flow(useProps, PureNotificationSettings), {
  displayName: 'NotificationSettings'
});